import type { ReactNode } from 'react';

import { getDocumentDirection } from '../../utils/rtl';

type DirectionRootProps = {
  language?: string;
  children: ReactNode;
  className?: string;
};

export const DirectionRoot = ({ language, children, className }: DirectionRootProps) => {
  const dir = getDocumentDirection(language);
  const lang = language?.toLowerCase() ?? 'en';

  return (
    <div dir={dir} lang={lang} className={className}>
      {children}
    </div>
  );
};
